import { CommonModule, DecimalPipe } from '@angular/common';
import { NgModule } from '@angular/core';

import { CurrencyInputDirective } from './curency-input/currency-input.directive';
import { FormPasswordDirective } from './form-password/form-password.directive';

@NgModule({
  declarations: [FormPasswordDirective, CurrencyInputDirective],
  imports: [CommonModule],
  providers: [DecimalPipe],
  exports: [FormPasswordDirective, CurrencyInputDirective]
})
export class DirectiveModule {}
